module.exports = __webpack_public_path__ + "static/media/ContactUsbg@2x.d86173e2.png";